import { FunctionComponent } from 'react'
import { Icon } from 'src/componentsV2/CoreUX/primitives/Icon/Icon'
import { ExpressDisclaimerProps } from './ExpressDisclaimer.types'
import './ExpressDisclaimer.scss'
import {
  UXComponentType,
  UXComponentVersion
} from 'src/componentsV2/CoreUX/UXComponentRenderer/uxComponent.types'
import { Color } from 'src/componentsV2/CoreUX/styles/color.styles'
import { Text } from 'src/componentsV2/CoreUX/primitives/Text/Text'
import { TextStyle } from 'src/componentsV2/CoreUX/styles/text.styles'

export const ExpressDisclaimer: FunctionComponent<ExpressDisclaimerProps> = ({
  icon,
  body
}) => {
  return (
    <section
      className="express-disclaimer"
      aria-label="Express order disclaimer">
      <figure className="express-disclaimer__icon" role="presentation">
        <Icon
          type={UXComponentType.Icon}
          version={UXComponentVersion.V2}
          attributes={{
            asset: icon,
            size: 'large',
            color: Color.FontPrimary
          }}
        />
      </figure>
      <Text
        type={UXComponentType.Text}
        version={UXComponentVersion.V2}
        attributes={{
          value: body,
          color: Color.FontSecondary,
          style: TextStyle.BaseLarge
        }}
      />
    </section>
  )
}
